<div
  class="unit-container"
  [class.overdue-border]="hasOverdueAssignments"
  (click)="navigate(gradeUnit.unitNumber)"
>
  <ng-container>
    <div class="card-header grade-text">{{ gradeText }}</div>
  </ng-container>
  <div class="cover-image">
    <img
      [src]="gradeUnit.unitCoverImageUrl"
      [alt]="getAltText(gradeUnit.unitNumber)"
    />
  </div>
  <div class="score-container">
    <div *ngIf="scorePreview" class="unit-title score-header-text">
      Unit {{ gradeUnit.unitNumber }} Score
    </div>
    <div *ngIf="scorePreview" class="unit-student-score">
      {{ studentScore }}/{{ unitTotalScore }}
    </div>
  </div>
  <mat-card-footer [ngStyle]="getStyles()">
    <mat-card-title>
      <h3 [matTooltip]="gradeUnit.unitTitle">{{ gradeUnit.unitTitle }}</h3>
      <p [matTooltip]="gradeUnit.unitDescription">
        {{ gradeUnit.unitDescription }}
      </p>
    </mat-card-title>
  </mat-card-footer>
</div>
